import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { useScope } from "@/hooks/useScope";

export function useSettingsEntity() {
  const { identifier } = useParams<{ identifier: string }>();
  const { entities, accounts, isLoadingAccounts } = useScope();

  return useMemo(() => {
    const entity =
      entities?.find((item) => item?.identifier === identifier) ?? null;
    const account =
      accounts?.find((item) => item?.entity?.identifier === identifier) ?? null;

    // No business yet may only be the person's businesses not read yet.
    return { identifier, entity, account, isLoading: isLoadingAccounts };
  }, [accounts, entities, identifier, isLoadingAccounts]);
}
